import React, { useState } from "react";
import { UpdatePaymentDetailsTypes } from "../../UpdatePaymentDetailsTypes";
import { UpdateDetailsErrorScreen } from "../ErrorScreens/UpdateDetailsErrorScreen";
// import { UpdateNotifications } from '../UpdateNotifications';
import { UpdatePaymentDetails } from "../UpdatePaymentDetails/UpdatePaymentDetails";
import { UpdatePaymentContext } from "../context/updatePaymentContext";
import {
  CARD_PROCESSOR_SHOW_ON_PAYMENT,
  CARD_PROCESSOR_STATUS,
  CARD_PROCESSOR_TYPE
} from "../../../../components/syrapayHostedForm/Constants";
import { updateTenant } from "@codeparva/v11-tfw-api-library";

export const UpdatePaymentDetailsPage = ({
  ledgerId,
  facilityId,
  public_key,
  ledgerData,
  paymentMethod,
  tenantId,
  cardProcessorIds,
  tenantToken
}: UpdatePaymentDetailsTypes.TUpdatePaymentPage) => {
  const [hasError, setHasError] = useState<boolean>(false);

  const cardProcessorId = cardProcessorIds.data.filter(
    (indivMethod: any) =>
      indivMethod.value.processor_type === CARD_PROCESSOR_TYPE &&
      indivMethod.value.status === CARD_PROCESSOR_STATUS &&
      indivMethod.value.show_on.includes(CARD_PROCESSOR_SHOW_ON_PAYMENT)
  )[0]?.id;

  const defaultCardInfo = {
    expiration_date: {
      month: "N/A",
      year: "N/A"
    },
    billing_info: {
      address: {
        line1: "N/A",
        zip_code: "N/A"
      },
      name: "N/A"
    },
    masked_card_number: "0000-0000-0000-0000"
  };

  const {
    financials: {
      card_info = defaultCardInfo,
      preferred_payment_method_id = "0"
    } = {
      card_info: defaultCardInfo,
      preferred_payment_method_id: "0"
    }
  } = ledgerData;
  const cardType =
    paymentMethod &&
    paymentMethod.data.filter((indivPaymentMethod: any) => {
      if (
        indivPaymentMethod.value.type === "Credit_Card" &&
        indivPaymentMethod.value.status === "Active" &&
        indivPaymentMethod.id === preferred_payment_method_id
      ) {
        return indivPaymentMethod;
      }
    });

  const showErrorScreen = () => {
    return <UpdateDetailsErrorScreen setError={setHasError} />;
  };
  const callBackHandler = async (
    updateRequest: any,
    setNotification: any,
    setIsSuccess: any
  ) => {
    const apiRequest = {
      ledger: [
        {
          id: ledgerId,
          __action_type: "Update",
          financials: {
            ...updateRequest
          }
        }
      ]
    };

    const [updateErr] = await updateTenant({
      updateTenantReq: apiRequest,
      tenantId,
      facilityId,
      tenantToken
    });
    if (updateErr) {
      console.error("Error from update contact details ", updateErr);
      setHasError(true);
    } else {
      setNotification(true);
      setIsSuccess(true);
      setTimeout(() => {
        setNotification(false);
      }, 1000);
    }
  };

  const props = {
    callBackHandler,
    public_key,
    cardDetails: card_info === null ? {} : card_info,
    paymentMethod,
    preferred_payment_method_id,
    cardType: cardType[0]?.value.description || "",
    cardProcessorId,
    facilityId,
    tenantToken
  };

  return (
    <UpdatePaymentContext.Provider value={props}>
      {hasError ? (
        showErrorScreen()
      ) : (
        <>
          {/* {isSubmitted && <UpdateNotifications status={isSuccessFull} />} */}
          <div className="updatePaymentDetailsParent">
            <UpdatePaymentDetails {...props} />
          </div>
        </>
      )}
    </UpdatePaymentContext.Provider>
  );
};
